/* LAB Color — Productlabel bol tekstscaling */
(function() {
  function measureText(text, fontSize, font) {
    var c = document.createElement('canvas');
    var ctx = c.getContext('2d');
    ctx.font = '700 ' + fontSize + 'px ' + font;
    return ctx.measureText(text).width;
  }

  function fitTextInBol(bolEl) {
    var inner = bolEl.querySelector('.product-label-bol__inner');
    if (!inner) return;
    var spans = inner.querySelectorAll('span');
    if (!spans.length) return;

    var lines = Array.from(spans).map(function(s) {
  return s.textContent.trim() || ' ';
});

    var diameter = bolEl.offsetWidth;
    if (!diameter) return;

    var font = 'DallasBold, Arial Narrow, Arial, sans-serif';
    var lineHeight = 1.12;
    var r = diameter * 0.32;

    var lo = 4, hi = diameter * 0.5, best = lo;

    while (hi - lo > 0.3) {
      var mid = (lo + hi) / 2;
      var totalH = lines.length * mid * lineHeight;
      var halfH = totalH / 2;

      var fits = lines.every(function(line, i) {
        var rowTop    = i * mid * lineHeight - halfH;
        var rowBottom = rowTop + mid * lineHeight;
        var worstY = Math.max(Math.abs(rowTop), Math.abs(rowBottom));
        if (worstY > r) return false;
        var chordHalf = Math.sqrt(Math.max(0, r * r - worstY * worstY));
        return measureText(line, mid, font) / 2 <= chordHalf;
      });

      if (fits) { best = mid; lo = mid + 0.3; }
      else { hi = mid - 0.3; }
    }

    spans.forEach(function(s) {
  s.style.fontSize = Math.floor(best) + 'px';
  s.style.lineHeight = lineHeight.toString();
});
bolEl.classList.add('is-ready');
  }

  function initLabels() {
    document.querySelectorAll('.product-label-bol').forEach(fitTextInBol);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function() {
      initLabels();
      setTimeout(initLabels, 300);
    });
  } else {
    setTimeout(initLabels, 500);
  }

  window.addEventListener('resize', initLabels);
})();